<template>
  <!--
    Superfan+ column: the Superfan status badge + the See Benefits action.
  -->
  <div class="flex min-w-0 flex-1 flex-col gap-3">
    <span class="text-[15px] font-semibold uppercase leading-[22px] text-text">
      {{ t("channel.profileCard.superfanColumn") }}
    </span>

    <div class="flex flex-row flex-wrap items-center gap-3">
      <span
        class="inline-flex h-8 items-center gap-1 rounded-full bg-surface px-2 py-1 text-[13px] font-semibold leading-[20px] text-text drop-shadow-[1px_4px_10.5px_rgba(0,0,0,0.13)]"
        data-testid="channel-profile-card-superfan-status"
      >
        <PremiumBadge v-if="isSuperfan" size="sm" class="inline" />
        <Icon
          v-else
          icon="mdi:star-outline"
          class="size-4 text-icon-secondary"
          aria-hidden="true"
        />
        {{
          isSuperfan
            ? t("channel.profileCard.active")
            : t("channel.profileCard.freeMember")
        }}
      </span>
    </div>

    <button
      type="button"
      class="mt-auto flex h-[50px] w-full items-center justify-center rounded-full border border-border bg-surface px-4 text-[15px] font-medium leading-[20px] text-text transition-colors hover:bg-black/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-brand"
      data-testid="channel-profile-card-see-benefits"
      @click="emit('see-benefits')"
    >
      {{ t("channel.profileCard.seeBenefits") }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { Icon } from "@iconify/vue";
import PremiumBadge from "@/components/badge/premium-badge.vue";

defineProps<{
  isSuperfan: boolean;
}>();

const emit = defineEmits<{
  "see-benefits": [];
}>();

const { t } = useI18n();
</script>
